import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

function Dashboard() {
  const stats = [
    { label: 'Total Projects', value: '12', change: '+3 this month', icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
    { label: 'Active Users', value: '47', change: '+12 this week', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
    { label: 'New Prospects', value: '23', change: '5 uncontacted', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
    { label: 'Uptime', value: '99.9%', change: 'Last 30 days', icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' },
  ];

  const recentProjects = [
    { name: 'techflow-api-prod', status: 'ready', type: 'ski', created: '2h ago' },
    { name: 'datascale-pipeline', status: 'provisioning', type: 'data', created: '5h ago' },
    { name: 'securebase-backend', status: 'ready', type: 'aws', created: '1d ago' },
  ];

  const recentActivity = [
    { action: 'Project created', details: 'techflow-api-prod', user: 'Sarah Chen', time: '2h ago' },
    { action: 'User invited', details: 'john@techflow.com', user: 'System', time: '3h ago' },
    { action: 'Prospect contacted', details: 'Acme Corp', user: 'Marcus R.', time: '5h ago' },
    { action: 'Deployment completed', details: 'datascale-pipeline', user: 'System', time: '6h ago' },
  ];

  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)]">
      <Sidebar />

      {/* Main Content */}
      <div className="ml-64 p-8">
        {/* Header */}
        <header className="mb-8 fade-in-up">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-display mb-2" style={{ color: 'var(--color-text-primary)' }}>
                Dashboard <span className="gradient-text">Overview</span>
              </h1>
              <p style={{ color: 'var(--color-text-secondary)' }}>
                Monitor your projects and activity
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="px-4 py-2 bg-[var(--color-bg-surface)] border rounded-lg" style={{ borderColor: 'var(--color-border)' }}>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 pulse-dot" />
                  <span className="text-sm text-mono" style={{ color: 'var(--color-text-secondary)' }}>All systems operational</span>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="card fade-in-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 113, 170, 0.1)' }}>
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    style={{ color: 'var(--color-primary)' }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d={stat.icon}
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-sm mb-2" style={{ color: 'var(--color-text-muted)' }}>{stat.label}</h3>
              <p className="text-4xl font-bold text-display mb-1" style={{ color: 'var(--color-primary)' }}>{stat.value}</p>
              <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>{stat.change}</p>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="card mb-8 fade-in-up delay-400">
          <h2 className="text-xl font-bold text-display mb-6 flex items-center" style={{ color: 'var(--color-text-primary)' }}>
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ color: 'var(--color-primary)' }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Link to="/projects/new" className="btn-primary text-center">
              <span className="flex items-center justify-center">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Create Project
              </span>
            </Link>
            <Link to="/users" className="btn-secondary text-center">
              Manage Users
            </Link>
            <Link to="/analytics" className="btn-secondary text-center">
              View Analytics
            </Link>
          </div>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Recent Projects */}
          <div className="card fade-in-up delay-500">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-display flex items-center" style={{ color: 'var(--color-text-primary)' }}>
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  style={{ color: 'var(--color-primary)' }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
                Recent Projects
              </h2>
              <Link to="/projects" className="text-sm hover:underline" style={{ color: 'var(--color-primary)' }}>
                View all →
              </Link>
            </div>
            <div className="space-y-4">
              {recentProjects.map((project, i) => (
                <div key={i} className="flex items-center justify-between p-4 bg-[var(--color-bg-elevated)] rounded-lg border transition-all" style={{ borderColor: 'var(--color-border)' }}>
                  <div className="flex items-center space-x-4">
                    <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 113, 170, 0.1)' }}>
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        style={{ color: 'var(--color-primary)' }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                        />
                      </svg>
                    </div>
                    <div>
                      <p className="font-mono text-sm" style={{ color: 'var(--color-text-primary)' }}>{project.name}</p>
                      <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>{project.created}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <span className="badge badge-primary text-xs">{project.type}</span>
                    <span className={`badge ${project.status === 'ready' ? 'badge-success' : 'badge-warning'} text-xs`}>
                      {project.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div className="card fade-in-up delay-500">
            <h2 className="text-xl font-bold text-display mb-6 flex items-center" style={{ color: 'var(--color-text-primary)' }}>
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{ color: 'var(--color-primary)' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Activity Log
            </h2>
            <div className="space-y-4">
              {recentActivity.map((activity, i) => (
                <div key={i} className="flex items-start space-x-4 p-4 bg-[var(--color-bg-elevated)] rounded-lg border" style={{ borderColor: 'var(--color-border)' }}>
                  <div className="w-2 h-2 rounded-full mt-2 pulse-dot" style={{ backgroundColor: 'var(--color-primary)' }} />
                  <div className="flex-1">
                    <p className="text-sm" style={{ color: 'var(--color-text-primary)' }}>
                      <span className="font-medium" style={{ color: 'var(--color-primary)' }}>{activity.action}</span>: {activity.details}
                    </p>
                    <p className="text-xs mt-1" style={{ color: 'var(--color-text-muted)' }}>
                      {activity.user} · {activity.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
